import { Injectable } from '@angular/core';
import { Router, Route, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad } from '@angular/router';
import { Location } from '@angular/common';
import { LocalStorageService } from 'angular-2-local-storage';
import { AuthService } from './auth.service';
import { ConfigService } from '../config.service';

@Injectable()
export class NotAuthenticatedGuard implements CanActivate, CanLoad {

    constructor(private _auth: AuthService, private router: Router, private _localStorage: LocalStorageService, private location: Location) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (route.routeConfig.path === 'customerDetails/:id') {
            const id = route.params.id.replace(/^0+/, '');
            this._localStorage.set('customerDetailsId', id);

            if (ConfigService.app.oauthExternal) {
                this.router.navigate(['/loginExternal']);
            } else {
                this.router.navigate(['/login']);
            }
        }
        return this.checkLogin();
    }

    public canLoad(route: Route): Promise<boolean> {
        const pathFragments = this.location.path().split('/');
        if (pathFragments[2] && pathFragments[2] !== '') {
            const id = pathFragments[2].replace(/^0+/, '');
            this._localStorage.set('customerDetailsId', id);
        }
        return this.checkLogin();
    }

    checkLogin(): Promise<boolean> {
        return this._auth.isAuthenticated().then( user => {
            if (user) {
                const customerDetailsId: any = this._localStorage.get('customerDetailsId');
                if (customerDetailsId && customerDetailsId !== '') {
                    this.router.navigate(['customerAnalysis']);
                } else {
                    this.router.navigate(['']);
                }
            }
            return !user;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/not-authenticated.guard.ts